import { PlayWindow } from "../api";
import { CreateElement, Rect, Scale, Size } from "../MyHelpers";
import { ZIndex } from "../ZIndex";
import { WinLines } from "./WinLines/WinLines";

export class WinLineNumbersMarker
{
	public element: HTMLElement;
	public containerElement: HTMLElement;

	public lineIndex: number;
	public backgroundElement : HTMLElement;

	public constructor() 
	{
		this.containerElement = CreateElement("div", {classes: ["line-marker-container"], style: {
			//flexGrow: "1",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			height : "10%",
			margin : Scale.fhpx(5),
			//padding : Scale.fhpx(5),
		}});
		

		this.element = CreateElement("div", {classes: ["line-marker-number"], innerHTML: "00", style: {
			borderRadius: Scale.XYpx(25),
			width: "98%",
			//height : "63%",
			textAlign: "center",
			fontFamily: "NotoSansDisplay-Bold", // default font
			fontSize: Scale.fhpx(32),
			color: "white",
			textShadow: "0px 0px 2px black, 0px 0px 4px black",
			margin: "auto",
			display : "flex",
			
			
		}});
		this.element.style.zIndex=ZIndex.WinLines.toString();

		this.containerElement.appendChild(this.element);

		this.backgroundElement = CreateElement("div", {classes: ["line-marker-background"], style: {
			borderRadius: Scale.XYpx(25),
			width: "95%",
			height : "10%",
			position : "absolute",			
			
		}});

		this.containerElement.appendChild(this.backgroundElement);
		

	}

	public Show(lineIndex: number): void {
		this.element.innerHTML = "" + (lineIndex + 1);
		this.element.style.visibility = "visible";
	}

	// public Hide(): void {
	// 	this.element.style.visibility = "hidden";
	// }
}

export class WinLineNumbersMarkers
{
	private leftMarkers: WinLineNumbersMarker[] = [];
	private leftVisibleMarker: WinLineNumbersMarker = null;

	private rightMarkers: WinLineNumbersMarker[] = [];
	private rightVisibleMarker: WinLineNumbersMarker = null;

	private leftContainer: HTMLElement = null;
	private rightContainer: HTMLElement = null;

	private leftGroup : HTMLElement []= [];
	private rightGroup : HTMLElement []= [];


	//private view: HTMLElement = null;
	private lines: number[][] = [];
	private winLines : WinLines;

	constructor(slotWindow: Rect, slotWindowSymbolSize: PlayWindow, lines: number[][], winLines: WinLines) 
	{
		let symbolHeight = slotWindow.height / slotWindowSymbolSize.Height;

		let leftWidth: number = Scale.W(70);
		let leftOffset: number = Scale.X(-3);

		let rightWidth: number = Scale.W(70);
		let rightOffset: number = Scale.X(-3);

		this.leftContainer = CreateElement("div", {classes: ["line-markers-left"], style: {
			position: "absolute",
			top: slotWindow.y + "px",
			height: slotWindow.height + "px",
			left: (slotWindow.x - leftWidth - leftOffset) + "px",
			width: leftWidth + "px",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			alignContent : "center",
		}});

		this.leftContainer.style.zIndex=ZIndex.WinLines.toString();

		this.rightContainer = CreateElement("div", {classes: ["line-markers-right"], style: {
			position: "absolute",
			top: slotWindow.y + "px",
			height: slotWindow.height + "px",
			left: (slotWindow.x + slotWindow.width + rightOffset) + "px",
			width: rightWidth + "px",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			alignContent : "center",
		}});

		this.rightContainer.style.zIndex=ZIndex.WinLines.toString();
		//CREATE 3 GROUPS
		for (let group = 0 ; group < 3 ; group++){
			this.leftGroup[group] = CreateElement("div", {classes: ["line-markers-groupLeft-"+group], style: {
				position: "relative",				
				height: slotWindow.height / 3 + "px",				
				width: rightWidth + "px",		
				display : "flex" , 
				alignContent : "center",
				flexDirection : "column",
				justifyContent : "center",
				alignItems : "center",
				
			}});

			this.leftContainer.appendChild (this.leftGroup[group]);

			this.rightGroup[group] = CreateElement("div", {classes: ["line-markers-groupRight-"+group], style: {
				position: "relative",				
				height: slotWindow.height / 3 + "px",				
				width: rightWidth + "px",
				display : "flex" , 
				alignContent : "center",
				flexDirection : "column",
				justifyContent : "center",
				alignItems : "center",					
			}});
			this.rightContainer.appendChild (this.rightGroup[group]);
		}
		
		
		for (let lineIndex = 0; lineIndex < lines.length; lineIndex++) {

			// create markers
			let leftMarker: WinLineNumbersMarker = new WinLineNumbersMarker();
			let rightMarker: WinLineNumbersMarker = new WinLineNumbersMarker();
			//Append Left Group
			let groupLeft = lines[lineIndex][0]
			this.leftGroup[groupLeft].appendChild(leftMarker.containerElement);
			leftMarker.backgroundElement.style.backgroundColor = winLines.GetColor(lineIndex).toRgb();

			leftMarker.Show(lineIndex);

			//Append Right Group
			let groupright = lines[lineIndex][lines[lineIndex].length-1];
			this.rightGroup[groupright].appendChild(rightMarker.containerElement);
			rightMarker.Show(lineIndex);
			rightMarker.backgroundElement.style.backgroundColor = winLines.GetColor(lineIndex).toRgb();
			
			// hide markers by default
			//leftMarker.Hide();
			//rightMarker.Hide();
			if(lines.length <= 10 ){
				rightMarker.containerElement.style.height = Scale.Hpx(70);
				rightMarker.backgroundElement.style.height = Scale.Hpx(70);
				//rightMarker.element.style.height = Scale.Hpx(20);

				
				leftMarker.containerElement.style.height = Scale.Hpx(70);
				leftMarker.backgroundElement.style.height = Scale.Hpx(70);
				//leftMarker.element.style.height = Scale.Hpx(20);
			}
			this.leftMarkers.push(leftMarker);
			this.rightMarkers.push(rightMarker);	
			
		}
		this.lines = lines;	
		this.winLines = winLines;
			
	}

	public Show(lineIndex: number): void {


		let rowLeft = this.lines[lineIndex][0];


		this.leftVisibleMarker = this.leftMarkers[lineIndex];
		this.leftVisibleMarker.backgroundElement.style.transform = "scale(1.25)";
		// this.leftVisibleMarker.Show(lineIndex);

		let rowRight = this.lines[lineIndex][this.lines[lineIndex].length - 1];

		this.rightVisibleMarker = this.rightMarkers[lineIndex];
		this.rightVisibleMarker.backgroundElement.style.transform = "scale(1.25)";
		// this.rightVisibleMarker.Show(lineIndex);
	}



	public Hide(): void {
		if (this.leftVisibleMarker != null) {
			this.leftVisibleMarker.backgroundElement.style.transform = "scale(1)";
			this.leftVisibleMarker = null;
		}

		if (this.rightVisibleMarker != null) {
			this.rightVisibleMarker.backgroundElement.style.transform = "scale(1)";
			this.rightVisibleMarker = null;
		}
	}

	public LeftView(): HTMLElement {
		return this.leftContainer;
	}

	public RightView(): HTMLElement {
		return this.rightContainer;
	}
}